import { getAboutPage } from "../../../config/aboutContent.js";
import { buildAnimatedHeading } from "../../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../../components/SectionPill.js";

export function createAboutValuesSection() {
  const { values } = getAboutPage();
  const section = document.createElement("section");
  section.id = "values";
  section.className = "section about-values";

  section.innerHTML = `
    <div class="section__inner">
      <div class="about-values__intro reveal">
        ${buildSectionPillRow(values.badge)}
        <h2 class="about-values__title">${buildAnimatedHeading(values.titleSegments)}</h2>
        <p class="about-values__subtitle">${values.subtitle}</p>
      </div>
      <div class="about-values__grid">
        ${values.items
          .map(
            (item, i) => `
          <article class="about-values__card reveal" style="--delay: ${0.06 * (i + 1)}s; --value-i: ${i}">
            <span class="about-values__index">${item.index}</span>
            <h3>${item.title}</h3>
            <p>${item.body}</p>
          </article>
        `
          )
          .join("")}
      </div>
    </div>
  `;

  return section;
}
